import Vue from 'vue'
import Router from 'vue-router'
import store from "../store";

import HomePage from '.././components/HomePage';
import DetailPage from '.././components/DetailPage';
import CodeApp from '../components/CodeApp';
import CourseApp from '../components/CourseApp';
import ErrorPage from "@/components/ErrorPage";
import DashBoard from "@/components/Login/DashBoard"
import Login from "@/components/Login/Login";
import Logout from "@/components/Login/Logout";
import PdfView from "@/components/PdfView/PdfView";
import Register from "@/components/Login/Register";

Vue.use(Router)
const router = new Router({
  routes: [
    { path: '/', component: HomePage },
    { path: '/code/edit', component: CodeApp,
      meta: {
        requiresAuth: true
      }
    },
    { path: '/course/code/edit', component: CourseApp,
      meta: {
        requiresAuth: true
      }
    },
    { path: '/detail', component: DetailPage },
    { path: '/certificate/:id', component: PdfView },

    { path: "*", component: ErrorPage },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    { path: '/logout',
      component: Logout,
      meta:{
        isLogout:true
      },
    },
    {
      path: "/register",
      name: "Signup",
      component: Register,
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashBoard,
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.isLogout)) {
    store.dispatch('setLogin',false);
    store.dispatch('setJWT',undefined);
    store.dispatch('setUser',undefined);
    next();

  }else {
    next();
  }
});


export default router;
